import { compact } from 'lodash';
import { useMemo } from 'react';
import { useUnsafeTranslation } from '../../../i18next';
import { useRoutes, useStringQueryParam } from '../../../routes';
import { useCurrentUser } from '../../../services/currentUser';
import { hasPermissionToAccessPage } from '../../../services/permissions';
import { parseReportingQueryParams } from '../services/data';

export const useReportsSideNav = () => {
  const { t } = useUnsafeTranslation();
  const { ROUTES } = useRoutes();
  const user = useCurrentUser();
  const [queryParam] = useStringQueryParam('q', '');
  return useMemo(() => {
    const q = parseReportingQueryParams(queryParam);
    return {
      items: compact([
        {
          label: t('Overview'),
          route: ROUTES.reports.overview
        },
        {
          label: t('Tasks'),
          route: ROUTES.reports.tasks
        },
        {
          label: t('Completion Drill-down'),
          route: ROUTES.reports.drilldown
        }
      ])
        .filter((r) => hasPermissionToAccessPage(user, r.route))
        .map((r) => ({
          label: r.label,
          path: r.route.url(q)
        }))
    };
  }, [ROUTES, t, user, queryParam]);
};
